// extracted by mini-css-extract-plugin
module.exports = {"flagBtn":"LanguageBtn_flagBtn__xs728","active":"LanguageBtn_active__1NSv7"};